import { useEffect } from 'react';
import { useAuth } from '../../contexts/ContextoAuth';
import { useWorkspace } from '../../contexts/ContextoWorkspace';
import { resetearIdentidadAnalitica, sincronizarIdentidadAnalitica } from './analitica';
import { resolverContextoIdentidadAnalitica } from './identidadAnalitica';

export function AnalyticsIdentitySync() {
  const { user, isAuthenticated } = useAuth();
  const { empresaId, establecimientoId, currentEmpresa } = useWorkspace();

  useEffect(() => {
    if (!isAuthenticated || !user) {
      resetearIdentidadAnalitica();
      return;
    }
    const contexto = resolverContextoIdentidadAnalitica(user, empresaId, currentEmpresa, establecimientoId);
    sincronizarIdentidadAnalitica(contexto);
  }, [isAuthenticated, user, empresaId, establecimientoId, currentEmpresa]);

  return null;
}
